import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[appNgSelectOptionDirective]',
  standalone: true,
})
export class NgSelectOptionDirective {
  constructor(public templateRef: TemplateRef<unknown>) {}
}
